import { render, staticRenderFns } from "./ImgFallback2.vue?vue&type=template&id=7cea3ad2&"
import script from "./ImgFallback2.vue?vue&type=script&lang=js&"
export * from "./ImgFallback2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7cea3ad2')) {
      api.createRecord('7cea3ad2', component.options)
    } else {
      api.reload('7cea3ad2', component.options)
    }
    module.hot.accept("./ImgFallback2.vue?vue&type=template&id=7cea3ad2&", function () {
      api.rerender('7cea3ad2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2zb6z4Q4lHfkU/JS/comp/ImgFallback2.vue"
export default component.exports